import { NgModule } from '@angular/core';
import { NpmLibComponent } from './npm-lib.component';

@NgModule({
  declarations: [NpmLibComponent],
  imports: [
  ],
  exports: [NpmLibComponent]
})
export class NpmLibModule { }
